import { useRootSelector } from "./useAppSelector";
import Api from "../api";
import { useEffect } from "react";
import jsonParams from "meta/features/json-params";
export const useCheckCosign = () => {
    const rootState = useRootSelector();
    useEffect(() => {
        if (rootState.isLogged && !jsonParams.MetaPortalInfo) {
            Api.checkCoSign().then((hasCoSignResult) => {
                if (hasCoSignResult.data) {
                    window.DialogManager.GlobalDialog.showIframe("Co-Sign", "eMAR/eMAR_CoSignNotification.aspx", "", 400, 150);
                }
            });
        }
    }, [rootState.isLogged]);
};
